import { Dispatch } from 'redux'
import { useThunkActions } from 'redux/actions/useThunkActions'

import { update } from 'redux/api/Widgets/ExportDashboardWidgets'

import * as widgetActions from '../actions'

import { WidgetPatchBody } from 'types/GlobalWidget'
import { skipFetchDataOnUpdate } from 'redux/api/Widgets'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'

function tryUpdateExportTableWidget(
  exportTableId: string,
  widgetId: string,
  body: WidgetPatchBody
) {
  return (dispatch: Dispatch) => {
    dispatch(widgetActions.update())

    update(exportTableId, widgetId, body)
      .then((response) => {
        dispatch(
          widgetActions.updateSuccess({
            data: response.data.data,
            skipFetchData: skipFetchDataOnUpdate(body)
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableUpdated))
      })
      .catch(() => {
        dispatch(widgetActions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableUpdatedFailed))
      })
  }
}

export const useExportTableWidgetActions = () => {
  return {
    tryUpdateExportTableWidget: useThunkActions(tryUpdateExportTableWidget)
  }
}
